/* eslint-disable import/prefer-default-export */
export const getUserPreferredTheme = (state) => state.userPreferredTheme;

export const getIsDarkModeOn = (state) => state.isDarkModeOn;

export const getUserPreferredThemeSetter = (state) =>
  state.setUserPreferredTheme;

export const getIsDarkModeOnSetter = (state) => state.setIsDarkModeOn;
